import { BuiltinViewScaleFactors } from "building-types/views/viewScaleConstants";
import { formatInchesFraction } from "./measurementUtils";

/** Format a view scale factor to a user-friendly fractional format. */
export function formatViewScaleFactor(value: number | string): string {
  const numValue = typeof value === "string" ? parseFloat(value) : value;

  const found = BuiltinViewScaleFactors.find((key) => {
    return Math.abs(key - numValue) < 0.001;
  });

  if (!found) {
    return value?.toString() ?? "";
  }

  return formatInchesFraction(found * 12, 64) + " = 1'-0\"";
}
